import React, { useState, useEffect } from 'react';
import { AddInfoKg } from './AddInfoKg';
import { getBDInfo, saveBDInfo } from './actions';

const data = require('./data/schema_bda.json');

export const BDAddInfoKg = ({ kgId, close }) => {
  const [initdata, setInitdata] = useState({});

  useEffect(() => {
   
    getData();
  }, []);

  const getData = async () => {
    const info = await getBDInfo(kgId);

    if (info?.data?.[0]?.['buildstat']) {
      setInitdata(info.data[0]['buildstat']);
    }
  };

  const saveData = async (formData) => {
    const data_obj = {
      '5000': formData['5000'],
      '5010': !!formData['5010'],
      '5020': formData['5020'],
      '5030': !!formData['5030'],
      '5040': !!formData['5040'],
      '5050': !!formData['5050'],
      '5060': !!formData['5060'],
      '5070': !!formData['5070'],
      '5080': !!formData['5080'],
      '5090': !!formData['5090'],
      '5100': !!formData['5100'],
      '5101': !!formData['5101'],
      '5110': !!formData['5110'],
      '5120': !!formData['5120'],
      '5130': !!formData['5130'],
      '5140': formData['5140'],
      '5150': formData['5150'],
      '5160': formData['5160'],
      '5161': formData['5161'],
      '5162': formData['5162'],
      'schelter_own': formData['schelter_own'],
      'schelter_rent': formData['schelter_rent'],
      'schelter_own_p': formData['schelter_own_p'],
      'schelter_rent_p': formData['schelter_rent_p'],
      'schelter_type': formData['schelter_type']
    };

    const result = await saveBDInfo(kgId, data_obj);

    alert((result.data?.nModified && result.data?.nModified == 1) ? `Інформація збережена успішно` : `Вибачте, але виникла помилка під час збереження`);
    
  };

  return (
    <AddInfoKg 
      data={data} 
      initdata={initdata} 
      save={saveData} 
      close={close}
    />
  );
};